import moment from "moment";

const isIsoDate = (dateString) => {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(dateString)) {
    return false;
  }
  let date = new Date(dateString);
  return date?.toISOString() === dateString;
};

export const changeLocalDateTimeToUTC = (
  dateString,
  format = "MM-DD-YYTHH:mm:ss",
  formatOnlyDate = false
) => {
  let localDateTime = new Date(dateString);
  if (formatOnlyDate) {
    localDateTime = localDateTime.setHours(0, 0, 0, 0);
  }
  return moment(localDateTime).utc().format(format);
};

export default function formatDate(date, format = "MM/DD/YY") {
  const mDate = moment(date);
  const isIsoString = isIsoDate(date);
  let formattedDate = null;
  if (mDate.isValid()) {
    if (isIsoString) {
      const shortISODate = date.substring(0, 10);
      formattedDate = moment(shortISODate).format(format);
    } else {
      formattedDate = moment(date).format(format);
    }
  }
  return formattedDate;
}
